import Vuetify from 'vuetify/lib'
import ru from 'vuetify/lib/locale/ru'
import variables from '@/assets/scss/exports.scss'
import '@mdi/font/css/materialdesignicons.css'


const lighttheme = {
  primary: variables['color-primary'],
  secondary: variables['color-secondary'],
  accent: variables['color-accent'],
  error: variables['color-error'],
  info: variables['color-info'],
  success: variables['color-success'],
  warning: variables['color-warning'],
}

// eslint-disable-next-line import/no-mutable-exports
export let vuetify

export const initPlugin = ({ Vue, app }) => {
  Vue.use(Vuetify)

  vuetify = new Vuetify({
    lang: {
      locales: { ru },
      current: 'ru',
    },
    theme: {
      themes: {
        light: lighttheme,
      },
    },
    icons: {
      defaultSet: 'mdi',
    },
  })

  // eslint-disable-next-line no-param-reassign
  app.vuetify = vuetify
}
